import React from "react";

const SIZES = {
  xs: "w-6 h-6 text-[10px]",
  sm: "w-8 h-8 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-12 h-12 text-base",
};

function initials(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function Avatar({ name, size = "md", className = "", ring = false }) {
  return (
    <div
      className={`rounded-full bg-gold/10 border border-gold/25 flex items-center justify-center text-gold font-semibold shrink-0 ${
        SIZES[size] || SIZES.md
      } ${ring ? "ring-2 ring-gold/20 ring-offset-2 ring-offset-ink-0" : ""} ${className}`}
      aria-label={name || "user"}
    >
      {initials(name)}
    </div>
  );
}

export default Avatar;
